(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["visconte-video-switcher"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.visconte-video-switcher').forEach((root) => {
    if (root.dataset.switcherInit) return;
    root.dataset.switcherInit = 'true';

    const track = root.querySelector('.visconte-video-switcher__track');
    const items = Array.from(root.querySelectorAll('.visconte-video-switcher__item'));
    if (!track || items.length < 2) return;

    const interval = parseInt(root.dataset.interval, 10) || 3000;
    let index = 0;

    const getVisibleCount = () => {
      const viewport = root.querySelector('.visconte-video-switcher__viewport');
      const itemWidth = items[0].getBoundingClientRect().width;
      if (!itemWidth) return 2;
      return Math.max(1, Math.round(viewport.getBoundingClientRect().width / itemWidth));
    };

    const getStep = () => {
      const gap = parseFloat(getComputedStyle(track).gap || '10') || 10;
      return items[0].getBoundingClientRect().width + gap;
    };

    setInterval(() => {
      const visibleCount = getVisibleCount();
      const maxIndex = Math.max(0, items.length - visibleCount);
      index = index >= maxIndex ? 0 : index + 1;
      const step = getStep();
      track.style.transform = `translateX(-${index * step}px)`;
    }, interval);
  });
  } catch(e) { console.error(e); }
})();

})();
